module.exports = __webpack_public_path__ + "static/media/menuMobile.0da78ed7.svg";